import { render, staticRenderFns } from "./DistrictsForm.vue?vue&type=template&id=36774690&scoped=true"
import script from "./DistrictsForm.vue?vue&type=script&lang=js"
export * from "./DistrictsForm.vue?vue&type=script&lang=js"
import style0 from "./DistrictsForm.vue?vue&type=style&index=0&id=36774690&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36774690",
  null
  
)

export default component.exports